'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["iconLeading", "iconTrailing", "children"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.js";
import { IconLeading } from "./IconLeading.js";
import { IconTrailing } from "./IconTrailing.js";
import { InputContainer } from "./InputContainer.js";
/**
 * The FormInputIcon wraps a FormInput and properly position a leading or trailing icon within it.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-forminputicon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/form#icon-labels) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/FormInputIcon)
 */
export var FormInputIcon = function FormInputIcon(_ref) {
  var iconLeading = _ref.iconLeading,
    iconTrailing = _ref.iconTrailing,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(InputContainer, Object.assign({
    $iconLeading: iconLeading,
    $iconTrailing: iconTrailing
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.FormInputIcon
  }), iconLeading && /*#__PURE__*/React.createElement(IconLeading, {
    "aria-hidden": "true",
    iconLeading: iconLeading
  }), children, iconTrailing && /*#__PURE__*/React.createElement(IconTrailing, {
    "aria-hidden": "true",
    iconTrailing: iconTrailing
  }));
};